import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Redirect que carrega a query string junto.
 *
 * `<Navigate to="/x" />` descarta `?a=b` — o que quebraria o atalho
 * `/admin/catalog?edit=<canonicalId>` da fila de Reports em silêncio (levaria
 * pra aba certa com o editor vazio, sem erro nenhum aparecer).
 */
export function RedirectKeepingSearch({ to }: { to: string }) {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  return <Navigate to={qs ? `${to}?${qs}` : to} replace />;
}
